import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArPriceInvestigationToolCreatedNotifyApproversProps extends BaseTemplateProps {
  request: {
    metadata?: {
      investigation_id?: string
    }
  }
  createdBy: {
    name: string
  }
}

export const ArPriceInvestigationToolCreatedNotifyApprovers: TemplateDefinition<ArPriceInvestigationToolCreatedNotifyApproversProps> =
  {
    renderParams: (props: ArPriceInvestigationToolCreatedNotifyApproversProps) => ({
      messageKey: 'notificationsDomain.templates.arPriceInvestigationToolCreatedNotifyApprovers',
      values: {
        investigationId: props?.request?.metadata?.investigation_id,
        createdBy: props?.createdBy?.name,
      },
    }),

    getLink: (props: ArPriceInvestigationToolCreatedNotifyApproversProps): string => {
      const investigationId = props?.request?.metadata?.investigation_id
      if (!investigationId) return ''
      return `/app/admin/catalog-admin/price-anomaly-investigation-detail/${investigationId}?receiver=approver`
    },
  }
